import {
  EtherscanProvider,
  OptimistReport,
  OptimistReportControls,
  OptimistReportProvider,
} from "@gearbox-protocol/deploy-tools-ui";
import {
  type ExecutionReport,
  TRACK_ROLES,
} from "@gearbox-protocol/liquidator-v2-config";
import { chains, type NetworkType } from "@gearbox-protocol/sdk/onchain";
import type { FC } from "react";
import { useLoaderData, useParams, useSearchParams } from "react-router-dom";

const OptimistExecutionRoute: FC = () => {
  const { executionId } = useParams();
  const report = useLoaderData() as ExecutionReport;
  const network = report.sdkState.network as NetworkType;
  const [searchParams] = useSearchParams();
  const marketConfigurator =
    (searchParams.get("marketConfigurator") as `0x${string}`) || undefined;
  const role = TRACK_ROLES.find(r => r === searchParams.get("role"));

  return (
    <OptimistReportProvider
      report={report}
      traceFilesPath="trace"
      marketConfigurator={marketConfigurator}
      initialRole={role}
    >
      <EtherscanProvider value={chains[network].id}>
        <div className="flex flex-col gap-4">
          <h2>Optimist report</h2>
          <OptimistReportControls />
        </div>

        <OptimistReport executionId={executionId} />
      </EtherscanProvider>
    </OptimistReportProvider>
  );
};

export default OptimistExecutionRoute;
